import { render, staticRenderFns } from "./SalesProfitMarginsGroup.vue?vue&type=template&id=184e52cb&"
import script from "./SalesProfitMarginsGroup.vue?vue&type=script&lang=js&"
export * from "./SalesProfitMarginsGroup.vue?vue&type=script&lang=js&"
import style0 from "./SalesProfitMarginsGroup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports